import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { setGiftCode } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewCom } from "@/mixins/index";
import uploadImagetow from '@/components/uploadImagetow';
import { itemTypeList } from "@/api/gmtool/packageCode";
export default {
  components: {
    uploadImagetow: uploadImagetow
  },
  mixins: [gmToolNew, gmToolNewCom],
  data: function data() {
    var _this = this;

    var validateNum = function validateNum(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseEnter')));
      } else {
        var num = Number(_this.paramsData.prefix.length) + Number(value);

        if (num < 4 || num > 10) {
          callback(new Error(_this.$t('giftCodeLengthError')));
        }

        callback();
      }
    };

    return {
      codeNum: 0,
      paramsData: {
        gift_code: '',
        start_time: '',
        end_time: '',
        count: '',
        type: '',
        giftCount: '',
        prefix: '',
        codeLen: '',
        rewardCount: '',
        rewards: []
      },
      dialogShow: false,
      ex_Val: [],
      typeList: [{
        label: this.$t('fixed'),
        value: 1
      }, {
        label: this.$t('random'),
        value: 2
      }],
      rules: {
        gift_code: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        start_time: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        end_time: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        count: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        giftCount: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        prefix: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        rewardCount: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        codeLen: [{
          required: true,
          validator: validateNum,
          trigger: "blur"
        }],
        rewards: [{
          required: true,
          message: this.$t('pleaseAddItem'),
          trigger: "blur"
        }],
        textid: [{
          required: true,
          message: this.$t('itemId'),
          trigger: "blur"
        }]
      }
    };
  },
  watch: {
    "paramsData.gift_code": {
      handler: function handler(val) {
        if (val) {
          this.codeNum = val.split(",").length;
        }
      },
      immediate: true
    }
  },
  created: function created() {},
  methods: {
    getTypeList: function getTypeList() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        itemTypeList({
          page_size: -1
        }).then(function (res) {
          if (res.code == 200) {
            _this2.itemType = res.data.map(function (item) {
              return {
                label: item.name,
                value: item.type_id
              };
            });
            resolve(_this2.itemType);
          } else {
            reject(new Error(_this2.$t('fetchItemTypeFailed')));
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    expireChange: function expireChange(e) {// this.paramsData.expire = e / 1000
    },
    discountChange: function discountChange() {
      this.$set(this.paramsData, 'original_cost', []);
      this.paramsData.original_cost = [];
    },
    open: function open(data) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.codeNum = 0;
                _this3.dialogShow = true;
                _context.next = 4;
                return _this3.getTypeList();

              case 4:
                _this3.itemType.map(function (i) {
                  _this3['itemType' + i.value] = _this3.szgmItemList.filter(function (item) {
                    return item.type == i.value;
                  });
                });

                if (data) {
                  _this3.paramsData = _objectSpread({}, data);
                  _this3.ex_Val = data.rewards ? JSON.parse(data.rewards) : [];
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    itemChange: function itemChange(index, type) {
      this.paramsData.rewards[index][type == 'ITEM' ? 'textid' : 'id'] = '';
    },
    clearData: function clearData() {
      var _this$paramsData;

      this.paramsData = (_this$paramsData = {
        gift_code: '',
        gift_id: '',
        name: '',
        desc: '',
        icon: '',
        refresh: 0,
        expire: '',
        num: '',
        delay_time: ''
      }, _defineProperty(_this$paramsData, "expire", ''), _defineProperty(_this$paramsData, "is_delay", 2), _defineProperty(_this$paramsData, "cost", []), _defineProperty(_this$paramsData, "has_discount", 2), _defineProperty(_this$paramsData, "original_cost", []), _defineProperty(_this$paramsData, "rewards", []), _this$paramsData);
      this.codeNum = 0;
      this.$refs.ruleForm.clearValidate();
    },
    domainType: function domainType(index, type) {
      this.paramsData.rewards[index].id = "";
      this.paramsData.rewards[index].textid = "";

      if (this.paramsData.rewards[index].num) {
        this.paramsData.rewards[index].num = '';
      }
    },
    addDomain: function addDomain(type) {
      this.paramsData[type].push({
        num: "",
        type: "",
        id: "",
        textid: "",
        quality: ""
      });
    },
    removeDomain: function removeDomain(type, index) {
      this.paramsData[type].splice(index, 1);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this4.reqLoading = true;
          var data = JSON.parse(JSON.stringify(_this4.paramsData));
          data.rewards.map(function (item) {
            // if (item.type != 1) {
            //   delete item.quality
            // }
            if (item.quality === "") {
              delete item.quality;
            }

            if (item.textid) {
              item.id = item.textid;
            }

            for (var i in item) {
              item[i] = parseInt(item[i]);
            }
          });
          data.rewards = JSON.stringify(data.rewards);
          setGiftCode(_objectSpread(_objectSpread({}, data), _this4.propsData)).then(function (res) {
            if (res.status == 200) {
              if (res.data.fail && res.data.fail.length != 0) {
                _this4.$message.error(_this4.$t('addSuccessWithFailures', {
                  failList: res.data.fail.toString()
                }));
              } else {
                _this4.$message({
                  message: _this4.$t('addSuccess'),
                  type: 'success'
                });
              }

              _this4.dialogShow = false;

              _this4.$emit('change');
            }
          }).finally(function () {
            _this4.reqLoading = false;
          });
        }
      });
    },
    fileUp: function fileUp(e, index) {
      this.paramsData.gift_code = e.data.toString();
    }
  }
};